import React, { useEffect, useState, useCallback } from "react";
import swal from "sweetalert";
import styles from "./DataTable.module.css";
import Pagination from "./Pagination";
import { purchaseListing } from "../../../Bookclosure/Services/ApiHandler";

const DataTable = ({ PurchaseID, filters = [], selectedFileName, onNoDataFound }) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);

  const formatHeading = (text) => {
    return text
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();
  };

  useEffect(() => {
    setActiveFilters(filters);
    setCurrentPage(1);
  }, [filters]);

  const loadData = useCallback(async () => {
    if (!PurchaseID) {
      console.error("PurchaseID is missing.");
      setColumns([]);
      setData([]);
      return;
    }

    try {
      const response = await purchaseListing(PurchaseID, {
        page: currentPage,
        pageSize: rowsPerPage,
        filters: activeFilters,
      });

      const res = response.data;

      const fetchedData = res.purchaseListing || [];
      setColumns(res.purchaseListingHeaders || []);
      setData(fetchedData);

      if (fetchedData.length > rowsPerPage || res.totalPages === 1) {
        setTotalPages(Math.ceil(fetchedData.length / rowsPerPage) || 1);
      } else {
        setTotalPages(res.totalPages || 1);
      }

      if (fetchedData.length === 0 && activeFilters.length > 0) {
        swal({
          title: "No Data Found",
          text: "Please check if you entered the correct values for the selected filter.",
          icon: "info",
        }).then(() => {
          if (typeof onNoDataFound === "function") {
            onNoDataFound();
          }
        });
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [PurchaseID, currentPage, rowsPerPage, activeFilters, onNoDataFound]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div className={styles.wrapper}>
      {selectedFileName && (
        <div className={styles.selectedFileBanner}>
          Displaying mapped file: <strong>{selectedFileName}</strong>
        </div>
      )}
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{formatHeading(col)}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {(data.length > rowsPerPage 
                ? data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage) 
                : data
             ).map((row, i) => (
              <tr key={i}>
                {columns.map((col) => (
                  <td key={col}>{row[col] ?? "-"}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default DataTable;
